import { render, staticRenderFns } from "./StepPhone.vue?vue&type=template&id=088d125b"
import script from "./StepPhone.vue?vue&type=script&lang=js"
export * from "./StepPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports